import React from 'react';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';
import { useLanguage } from '@/state/language/LanguageProvider';

export const DataImportPage: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-[var(--color-secondary-text)]">{t('dataImport.title')}</h1>
        <p className="mt-1 text-sm text-[var(--color-secondary-text)]">
          Import and manage your data sources
        </p>
      </div>
      
      <EmptyState
        title="Data Sources"
        count={0}
        message="No data sources configured yet. Get started by importing your first data source."
        action={
          <Button disabled>
            Import Data Source
          </Button>
        }
      />
    </div>
  );
}; 